import React from 'react';
import './styles/Footer.css';

const Footer = () => {
  return (
    <footer>
      <h3>Progetto React start2Impact, Markiyan Kmit </h3>
      <a href='https://github.com/mark1yan0/'>GitHub</a>
      <a href='https://mark1yan0.github.io/portfolio-repo/'>Portfolio</a>
    </footer>
  );
};

export default Footer;
